// extracted by mini-css-extract-plugin
export var callout = "callout-module--callout--6871a";
export var calloutAnimation = "callout-module--calloutAnimation--e76a4";
export var calloutButton = "callout-module--calloutButton--93302";
export var calloutButtonWrapper = "callout-module--calloutButtonWrapper--ae314";
export var calloutHeader = "callout-module--calloutHeader--2132d";
export var calloutSubheader = "callout-module--calloutSubheader--81928";
export var calloutWrapper = "callout-module--calloutWrapper--426f1";
export var spinDown = "callout-module--spinDown--ad11b";
export var spinUp = "callout-module--spinUp--4bc01";